import type { PayloadAction } from '@reduxjs/toolkit';
import type { OnboardingSignedUrlType, OnboardingStateType, OnboardingSteps } from './types';

const reducers = {
  changeStep: (state: OnboardingStateType, action: PayloadAction<OnboardingSteps>) => {
    state.step = action.payload;
  },
  setSignedUrl: (state: OnboardingStateType, action: PayloadAction<OnboardingSignedUrlType>) => {
    state.signedUrl = action.payload;
  },
};

export default reducers;
